import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;
const WhyChooseUs = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const [modalData, setModalData] = useState({
        id: null,
        heading: "",
        content: "",
        image_file: null,
        image_preview: null,
        image_name: "",
        old_image: null,
    });

    const [galleryImages, setGalleryImages] = useState([]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, [school_slug]);

    const fetchContent = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/home_page/get_why_choose/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                console.log(res.data);
                setGalleryImages(res.data.data || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- Handler --------------- */

    const handleEdit = (item) => {
        setIsEdit(true);
        setModalData({
            id: item.id,
            heading: item.heading || "",
            content: item.content || "",
            image_file: null,
            image_preview: `${baseAPIUrl}assets/images/why-choose-us/${item.why_choose_image}`,
            old_image: item.why_choose_image,
        });
        setShowModal(true);
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setModalData(prev => ({
                ...prev,
                image_file: file,
                image_name: file.name,   // ✅ auto image name
                image_preview: URL.createObjectURL(file),
            }));
        }
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this image?")) return;
        const formData = new FormData();
        formData.append("id", id);
        try {
            const res = await axios.post(
                `${baseAPIUrl}admin/home_page/delete_why_choose`,
                formData,
                { withCredentials: true }
            );

            // Remove from UI instantly
            if (res.data.status === 1) {
                setGalleryImages(prev => prev.filter(img => img.id !== id));
            } else {
                alert(res.data.message || "Delete failed");
            }
        } catch (err) {
            console.error(err.response);
            alert(err.response?.data?.message || "Failed to delete image");
        }
    };

    const handleSave = async () => {
        const formData = new FormData();

        formData.append("school_slug", school_slug);
        formData.append("heading", modalData.heading);
        formData.append("content", modalData.content);
        formData.append("image_name", modalData.image_name);
        

        if (modalData.image_file) {
            formData.append("image", modalData.image_file);
        }

        if (isEdit) {
            formData.append("id", modalData.id);
            formData.append("old_image", modalData.old_image);
        }

        try {
            const url = isEdit
                ? `${baseAPIUrl}admin/home_page/update_why_choose`
                : `${baseAPIUrl}admin/home_page/add_why_choose`;

            await axios.post(url, formData, {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            });

            setShowModal(false);
            fetchContent(); // reload table
        } catch (err) {
            console.error(err);
            alert("Failed to save image");
        }
    };



    /* ---------------- Submit ---------------- */


    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Why choose us</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Home page</li>
                                <li class="breadcrumb-item active">Why choose us</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4>All cards</h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="btn btn-primary" onClick={() => {
                                                setIsEdit(false);
                                                setModalData({
                                                    id: null,
                                                    image_name: "",
                                                    heading: "",
                                                    content: "",
                                                    image_file: null,
                                                    image_preview: null,
                                                    old_image: null,
                                                });
                                                setShowModal(true);
                                            }}>Add card</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover text-nowrap">
                                        <thead className="thead-light">
                                            <tr>
                                                <th style={{ width: "80px" }}>#</th>
                                                <th>Image</th>
                                                <th>Heading</th>
                                                <th>Content</th>
                                                <th style={{ width: "150px" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {galleryImages.length > 0 ? (
                                                galleryImages.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>

                                                        <td>
                                                            <img
                                                                src={`${baseAPIUrl}assets/images/why-choose-us/${item.why_choose_image}`}
                                                                alt="Why choos Us"
                                                                style={{
                                                                    width: "120px",
                                                                    height: "80px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "6px",
                                                                }}
                                                            />
                                                        </td>
                                                        <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>
                                                            {item.heading ? item.heading : <span className="text-muted">—</span>}
                                                        </td>
                                                        <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>
                                                            {item.content ? item.content  : <span className="text-muted">—</span>}
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-info mr-2"
                                                                onClick={() => handleEdit(item)}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>

                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(item.id)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No Card found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "flex",
                        alignItems: "center",      // ✅ vertical center
                        justifyContent: "center",  // ✅ horizontal center
                        backgroundColor: "rgba(0,0,0,0.5)",
                        inset: 0,
                        zIndex: 1050,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: "80%",  margin: 0, width: "100%" }}>
                        <div className="modal-content" style={{ maxWidth: "80%",  margin: "0 auto", width: "100%" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {isEdit ? "Edit Card" : "Add Card"}
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">

                                {/* Card heading */}
                                <div className="form-group">
                                    <label>Card heading</label>
                                    <input
                                        type="heading"
                                        className="form-control"
                                        rows="3"
                                        value={modalData.heading}
                                        onChange={(e) =>
                                            setModalData({ ...modalData, heading: e.target.value })
                                        }
                                    />
                                </div>

                                {/* Card content */}
                                <div className="form-group">
                                    <label>Content</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={modalData.content}
                                        onChange={(e) =>
                                            setModalData({ ...modalData, content: e.target.value })
                                        }
                                    ></textarea>
                                </div>

                                {/* Image Upload */}
                                <div className="form-group">
                                    <label>Image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                    />
                                </div>

                                {/* Preview */}
                                {modalData.image_preview && (
                                    <div className="mt-3">
                                        <img
                                            src={modalData.image_preview}
                                            alt="Preview"
                                            style={{
                                                maxWidth: "130px",
                                                maxHeight: "120px",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-success" onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >
    )
}
export default WhyChooseUs;